import { render, staticRenderFns } from "./PropertyLabel.vue?vue&type=template&id=b51cfea4&"
import script from "./PropertyLabel.vue?vue&type=script&lang=js&"
export * from "./PropertyLabel.vue?vue&type=script&lang=js&"
import style0 from "./PropertyLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports